import { Dispatch } from 'redux';

import { requestHandler } from '../../../api';

export const getUsedFundsForBusiness = async (
  dispatch: Dispatch,
  businessIdentifier: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/multiverse/business/used/${businessIdentifier}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getAvaialbleFundsForBusiness = async (
  dispatch: Dispatch,
  businessIdentifier: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/multiverse/business/available/${businessIdentifier}`,
    dispatch,
  });
  if (response) return response.data;
};

export const shareBusiness = async (
  dispatch: Dispatch,
  data: {
    businessIdentifier: string;
    fundId: number;
    expiresAt: string;
  },
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/multiverse/business/share`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const unshareBusiness = async (
  dispatch: Dispatch,
  data: {
    businessIdentifier: string;
    fundId: number;
  },
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/multiverse/business/unshare`,
    dispatch,
    data,
  });
  if (response) return response.data;
};
